<div class="card mb-3">
    <div class="card-body">
        <div class="d-flex align-item-center click" (click)="goTo()">
            <div class="flex-shrink-0 ">
                <div class="avtar avtar-s bg-light-primary">
                    <fa-icon [icon]="form.icona"></fa-icon>

                </div>
            </div>
            <div class="flex-grow-1 ms-3">
                <h6 class="mb-0 fw-bold"> {{form.name.replaceAll('_', ' ')}}</h6>
            </div>
        </div>
        <div class="bg-body-secondary p-3 mt-3 rounded" *ngIf="richiesteSequenziamento">
            <div class="card-body">
                <app-data-form-table [data]="richiesteSequenziamento"
                    [tipo]="'Richiesta Sequenziamento'"></app-data-form-table>
            </div>
        </div>
        <div class="bg-body-secondary p-3 mt-3 rounded" *ngIf="risultatiSequenziamento">
            <div class="card-body">
                <app-data-form-table [data]="risultatiSequenziamento"
                    [tipo]="'Risultato Sequenziamento'"></app-data-form-table>
            </div>
        </div>
    </div>
</div>